import { React, useState, useEffect } from "react";
import "./FilterPage.css"; //Styling
import { useParams } from "react-router-dom"; //Router
import { Header } from "../../components/common/Header.js"; //Child Comp
import { FilterTable } from "../../features/Filter/FilterTable/FilterTable.js"; //Child Comp
import { FilterResult } from "../../features/Filter/FilterResult/FilterResult.js"; //Child Comp
import { useSelector } from "react-redux"; //Redux
import { SideBar } from "../../features/SideBar/SideBar.js";

export const FilterPage = () => {
  let apiUtility = useSelector((state) => state.apiUtility);
  let genresList = [
    apiUtility.apiUtility.movGenreList,
    apiUtility.apiUtility.tvGenreList,
  ];

  let [showFilter, setShowFilter] = useState(true);

  return (
    <>
      <div className="filter-page">
        <Header />
        <div className="filter_page_wrapper">
          <div className="filter_page_title">
            PICK BY <br />
            GENRES & KEYWORDS
          </div>
          <div
            className={`filter_page_filter_table ${
              showFilter ? "show_filter_active" : "show_filter_inactive"
            }`}
          >
            <FilterTable
              genresList={genresList}
              setShowFilter={setShowFilter}
            />
          </div>
          <div
            className={`filter_page_result ${
              showFilter ? "show_filter_inactive" : "show_filter_active"
            }`}
          >
            <FilterResult
              apiUtility={apiUtility.apiUtility}
              setShowFilter={setShowFilter}
            />
          </div>
        </div>
      </div>
      <SideBar />
    </>
  );
};
